// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__Rb1OM","spinner":"Loader_spinner__iDFIv","centered":"Loader_centered__teS1R"};